export function loadPersistentState<S>(storageKey: string): S | null {
    try {
        const loaded = localStorage.getItem(storageKey)
        return loaded ? (JSON.parse(loaded) as S) : null
    } catch (ignore) {
        return null
    }
}

export function savePersistentState<S>(storageKey: string, state: S): void {
    return localStorage.setItem(storageKey, JSON.stringify(state))
}
